import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button } from 'reactstrap';

export default function RedeemKeyLink({ itemKey, onCopy, supplierLink }) {
  if (!supplierLink) {
    return (
      <CopyToClipboard text={itemKey} onCopy={onCopy}>
        <Button color="primary">
          <FormattedMessage id="reveal-key.redeem-key-link.copy" defaultMessage="Copy" />
        </Button>
      </CopyToClipboard>
    );
  }

  return (
    <CopyToClipboard text={itemKey} onCopy={onCopy}>
      <a href={`${supplierLink}${itemKey}`} alt="alt" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
        <FormattedMessage id="reveal-key.redeem-key-link.copy-and-redeem" defaultMessage="Copy & Redeem" />
      </a>
    </CopyToClipboard>
  );
}

RedeemKeyLink.propTypes = {
  itemKey: PropTypes.string,
  onCopy: PropTypes.func,
  supplierLink: PropTypes.string,
};

RedeemKeyLink.defaultProps = {
  itemKey: '',
  onCopy: () => {},
  supplierLink: '',
};
